import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { FileText, PawPrint, Search, Users } from 'lucide-react';
import { getAdminUsers, type AdminUser } from '../lib/api';

export default function AdminUsersPage() {
  const { getAccessTokenSilently } = useAuth0();
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isCurrent = true;
    const loadUsers = async () => {
      setLoading(true);
      try {
        const token = await getAccessTokenSilently();
        if (!token) throw new Error('Missing access token');
        const result = await getAdminUsers(token);
        if (isCurrent) setUsers(result);
      } catch (loadError) {
        if (isCurrent) setError(loadError instanceof Error ? loadError.message : 'Unable to load users');
      } finally {
        if (isCurrent) setLoading(false);
      }
    };
    void loadUsers();
    return () => { isCurrent = false; };
  }, [getAccessTokenSilently]);

  const visibleUsers = users.filter((user) => `${user.name} ${user.email}`.toLowerCase().includes(query.trim().toLowerCase()));

  return <>
    <div className="facility-page-heading"><div><p className="eyebrow">Administration</p><h1>Users</h1><p>Account holders across Actapet.</p></div><span className="users-total"><Users size={16} /> {users.length} {users.length === 1 ? 'user' : 'users'}</span></div>
    <div className="filter-row"><div className="search-field"><Search size={16} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search users" aria-label="Search users" /></div></div>
    {error && <p className="form-error facility-error" role="alert">{error}</p>}
    {loading ? <p className="facility-empty">Loading users...</p> : visibleUsers.length === 0 ? <p className="facility-empty">{query ? 'No users match this search.' : 'No users found.'}</p> : <div className="users-table-wrap"><table className="users-table"><thead><tr><th>User</th><th>Date joined</th><th><PawPrint size={14} /> Pets</th><th><FileText size={14} /> Documents</th></tr></thead><tbody>{visibleUsers.map((user) => <tr key={user.id}><td><strong>{user.name || 'Unnamed user'}</strong><span>{user.email}</span></td><td>{new Date(user.joined_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}</td><td>{user.pets_count}</td><td>{user.documents_count}</td></tr>)}</tbody></table></div>}
  </>;
}